/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'

 
export const getAllGetchkdUsers = createAsyncThunk('user/getAllGetchkdUsers', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.getchkdUser.getAllGetchkdUsers(params);
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getGetchkdUserHistory = createAsyncThunk('user/getGetchkdUserHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.getchkdUser.getGetchkdUserHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
